import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useCallback, useContext } from "react";
import InvoiceSequence from "../data/model/InvoiceSequence";
import Terminal from "../data/model/Terminal";
import { Q } from "@nozbe/watermelondb";
import { InvoiceSequenceContext } from "./context";

export const useInvoiceSequence = () => {
  const database = useDatabase();

  const sync = useCallback(async () => {
    const terminals = await database.get<Terminal>("terminals").query().fetch();
    const batchActions: InvoiceSequence[] = [];

    for (const terminal of terminals) {
      let maybeInvoiceSequence: InvoiceSequence | undefined;

      try {
        maybeInvoiceSequence = await database
          .get<InvoiceSequence>("invoice_sequence")
          .find(terminal.id);
      } catch (e) {}

      if (!maybeInvoiceSequence) {
        const action = database
          .get<InvoiceSequence>("invoice_sequence")
          .prepareCreate((sequence) => {
            sequence.terminal.id = terminal.id;
            sequence.sequence = terminal.invoiceSequence;
          });
        batchActions.push(action);
      } else {
        const action = maybeInvoiceSequence.prepareUpdate((sequence) => {
          sequence.sequence = terminal.invoiceSequence;
        });
        batchActions.push(action);
      }
    }
    await database.write(async () => {
      await database.batch(batchActions);
    });
  }, [database]);

  const getAndIncrementInvoiceSequence = useCallback(
    async (terminalId: string) => {
      const invoiceSequences = await database
        .get<InvoiceSequence>("invoice_sequence")
        .query(Q.where("terminal_id", terminalId))
        .fetch();

      const invoiceSequence = invoiceSequences[0];

      if (!invoiceSequence) {
        throw new Error("error.no-invoice-sequence-found");
      }

      const previousSequence = invoiceSequence.sequence;
      const newSequence = previousSequence + 1;

      await database.write(async () => {
        await invoiceSequence.update((sequence) => {
          sequence.sequence = newSequence;
        });
      });

      return previousSequence;
    },
    [database]
  );

  return {
    methods: {
      sync,
      getAndIncrementInvoiceSequence,
    },
  };
};

export const useInvoiceSequenceProvider = () => {
  const context = useContext(InvoiceSequenceContext);
  if (!context) {
    throw new Error("No InvoiceSequenceContext context was provided.");
  }
  return context;
};
